export default {
  error404: {
    heading: 'Ups, ¡lo siento!',
    notFound: 'La encuesta que estabas buscando no existe o ha sido movida.'
  }
};